import styles from "./Checkbox.module.css";
import React from "react";

interface ICheckboxProps {
  id?: string;
  label?: string;
  onCheck?: (x: boolean) => void;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = ({
  id,
  label,
  onCheck,
  checked,
  required,
  disabled,
}) => {
  const onChecked: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (onCheck && !disabled) {
      onCheck(e.target.checked);
    }
  };

  return (
    <div className={styles.inputWrapper}>
      <label className={styles.label}>
        <input
          type="checkbox"
          id={id}
          className={styles.input}
          onChange={onChecked}
          checked={checked}
          required={required}
          disabled={disabled}
        />
        <span className={styles.customCheckbox} />
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
